import React from 'react';
import { List } from '@mui/material';
import { differenceInMinutes } from 'date-fns';
import { IEvent } from '../../../Models/DTO/Event.model';
import EventItemContainer from './EventItem/EventItem.container';

interface EventListProps {
  events: IEvent[];
}

const getBreakTime = (events: IEvent[], index: number) => {
  const currentEvent = events[index];
  const nextEvent = events[index + 1];

  if (!nextEvent) {
    return -1;
  }

  return differenceInMinutes(new Date(nextEvent.start), new Date(currentEvent.end));
};

export const EventList = ({ events }: EventListProps) => (
  <List disablePadding>
    {events.map((event: IEvent, index: number) => (
      <EventItemContainer breakTime={getBreakTime(events, index)} event={event} key={index} />
    ))}
  </List>
);
